<form [formGroup]="form">
  <div class="row">
    <div class="col-md-12 form-group">
      <label>{{ 'workflow.name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['name']"
      ></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'workflow.description' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['description']"
        [inputType]="'textarea'"
        helpText="{{ 'error.maxlengthValue' | translate: { max: 255 } }}"
      ></app-input-with-error>
    </div>
    <div class="col-md-4 form-group">
      <label>{{ 'workflow.imageOrPdf' | translate }}</label>
      <p-fileupload
        [disabled]="!editable || form.disabled || uploadingFile"
        styleClass="ms-3"
        mode="basic"
        name="demo[]"
        chooseIcon="pi pi-upload"
        accept="image/*, application/pdf, .html"
        [customUpload]="true"
        (uploadHandler)="onUpload($event)"
        [auto]="true"
        [chooseLabel]="'browse' | translate"
      />
      @if (hasFile()) {
        <p-button
          type="button"
          severity="danger"
          [outlined]="true"
          icon="pi pi-trash"
          [label]="'workflow.removeFile' | translate"
          [disabled]="!editable || form.disabled || uploadingFile"
          (onClick)="removeFile()"
          data-testid="remove-workflow-file"
        />
      }

      <div class="form-text mb-2">
        {{ 'workflow.imageOrPdf-help' | translate }}
      </div>
    </div>
    <div class="col-md-8">
      <div class="workflow-preview">
        @if (previewType === 'pdf') {
          <object
            [data]="previewResourceUrl"
            type="application/pdf"
            width="100%"
            height="100%"
          ></object>
        } @else if (previewType === 'image') {
          <img
            [src]="previewUrl"
            alt="Uploaded Image"
            style="max-width: 100%; max-height: 200px"
          />
        } @else if (previewType === 'iframe') {
          <iframe
            [src]="previewResourceUrl"
            sandbox="allow-same-origin allow-scripts"
            referrerpolicy="no-referrer"
            loading="lazy"
            style="width: 100%; height: 100%"
          >
          </iframe>
        } @else if (previewType === 'html') {
          <iframe
            [src]="previewResourceUrl"
            sandbox=""
            referrerpolicy="no-referrer"
            loading="lazy"
            style="width: 100%; height: 100%"
          >
          </iframe>
        }
      </div>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'workflow.embedString' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['embedString']"
        [inputType]="'textarea'"
      ></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <app-input-with-error
        [control]="this.form.controls['createForOrganization']"
        [inputType]="'checkbox'"
        description="workflow.createForOrganization"
      ></app-input-with-error>
      <div class="form-text">
        {{ 'workflow.createForOrganization?' | translate }}
      </div>
    </div>
  </div>
  <app-error [error]="error"></app-error>
</form>
